<template>
	<span class="timeline__header"><slot></slot></span>
</template>

<style lang="scss">
@import '~@/styles/variables.scss';
@import '~@/styles/rtl-support-mixins';

$border-width: 11px;

.timeline {
	&__header {
		position: relative;
		top: -15px;
		background-color: $jw-color-lightblue--light;
		color: $jw-color-darkgray;
		font-weight: bold;
		padding: 2px 0;
		padding-inline-start: 3px;
		padding-inline-end: 6px;
		margin-inline-start: 10px;
		font-size: 13px;
		@include border-vertical-horizontal-radius('top', 'right', $jw-border-radius);
		@include border-vertical-horizontal-radius('bottom', 'right', $jw-border-radius);
		height: 22px;
		display: inline-block;

		&:after {
			top: 50%;
			border: $border-width solid transparent;
			content: ' ';
			height: 0;
			width: 0;
			position: absolute;
			pointer-events: none;
			border-inline-end-color: $jw-color-lightblue--light;
			margin-top: -$border-width;

			inset-inline-end: 100%;
		}
	}
}
</style>
